function objectWithoutProperties(obj, exclude) {
  var target = {}
  for (var k in obj)
    if (
      Object.prototype.hasOwnProperty.call(obj, k) &&
      exclude.indexOf(k) === -1
    )
      target[k] = obj[k]
  return target
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vertical-progress-wrapper",
      class: !_vm.isEmptyTimeline ? "progress-vertical" : "",
    },
    [
      _vm._l(_vm.timelineList, function (ref, idx) {
        var items = ref.items
        var sectionName = ref.sectionName
        return _c(
          "div",
          { key: sectionName + "-" + idx },
          [
            items[0]
              ? _c(
                  "b-row",
                  {
                    staticClass: "mt-4",
                    class: _vm.toHyphens(sectionName) + "-section-item",
                  },
                  [
                    _c(
                      "b-col",
                      { staticClass: "month-tag", attrs: { cols: "12" } },
                      [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "bold text-primary mb-4 text-capitalize",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.isCurrentMonth(sectionName)
                                    ? _vm.$t(
                                        "client-profile.messages.thisMonth"
                                      )
                                    : sectionName
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(items, function (ref, itemIdx) {
              var updatedAt = ref.updatedAt
              var createdAt = ref.createdAt
              var activityType = ref.activityType
              var scheduledDate = ref.scheduledDate
              var scheduledTime = ref.scheduledTime
              var complete = ref.complete
              var title = ref.title
              var rest$1 = objectWithoutProperties(ref, [
                "updatedAt",
                "createdAt",
                "activityType",
                "scheduledDate",
                "scheduledTime",
                "complete",
                "title",
              ])
              var rest = rest$1
              return _c(
                "b-row",
                {
                  key: sectionName + "-" + activityType + "-" + itemIdx,
                  staticClass: "mb-4 timeline-item",
                  class: _vm.toHyphens(sectionName) + "-section-item",
                },
                [
                  _c("b-col", { staticClass: "progress-item pr-0" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.left",
                            value: _vm.getTooltipTitle(
                              activityType,
                              updatedAt,
                              createdAt,
                              scheduledDate,
                              scheduledTime,
                              complete
                            ),
                            expression:
                              "\n            getTooltipTitle(\n              activityType,\n              updatedAt,\n              createdAt,\n              scheduledDate,\n              scheduledTime,\n              complete\n            )\n          ",
                            modifiers: { left: true },
                          },
                        ],
                        staticClass: "progress-item-circle nav-link clickable",
                        style:
                          "--progress-item-variation: " +
                          _vm.getItemVariation(activityType),
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleIconClick(activityType)
                          },
                        },
                      },
                      [
                        _c("i", {
                          class: _vm.parseClassItem(activityType),
                          staticStyle: {
                            "z-index": "50",
                            "font-size": "15px",
                            color: "white",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "timeline-item-content-wrapper" },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            _vm.getTimelineComponent(activityType),
                            _vm._b(
                              {
                                key:
                                  activityType +
                                  "-" +
                                  (rest.id ? rest.id : rest.threadId),
                                tag: "component",
                                attrs: {
                                  classname: "progress-item-image",
                                  "timeline-list": _vm.timelineList,
                                  "referrer-id": _vm.referrerId,
                                  items: items,
                                  "is-pinned":
                                    sectionName === "Pinned" ? true : false,
                                },
                                on: { pin: _vm.pinItem },
                              },
                              "component",
                              Object.assign(
                                {},
                                {
                                  updatedAt: updatedAt,
                                  createdAt: createdAt,
                                  activityType: activityType,
                                  scheduledDate: scheduledDate,
                                  scheduledTime: scheduledTime,
                                  complete: complete,
                                  title: title,
                                },
                                rest
                              ),
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.isEmptyTimeline
        ? _c(
            "b-row",
            { staticClass: "mt-5 pl-5" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12" } },
                [
                  _c("img", {
                    attrs: {
                      height: "100px",
                      src: require("@Broker/@Assets/icon/empty-timeline.png"),
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "text-light-gray mt-2" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.messages.noActivityToShow")) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }